/**
 * 动态导入辅助函数
 * 用于修复 Vite 构建后动态导入路径问题
 */

/**
 * 动态导入包装函数 - 简化版本
 * @param {Function} importFn - 原始的动态导入函数
 * @param {Array} chunkNames - 预加载的 chunk 名称
 * @returns {Promise} 导入的 Promise
 */
export function Ht(importFn, chunkNames) {
  // 直接执行导入函数，并添加错误处理
  return importFn().catch((error) => {
    console.error('动态导入失败:', error)
    // 重试一次
    console.log('尝试重新加载模块...')
    return importFn().catch((retryError) => {
      console.error('重试仍然失败:', retryError)
      throw retryError
    })
  })
}